import { createVanIconComponent } from "./van"

const CommentOutlined = createVanIconComponent("comment-o")
export default CommentOutlined
